import { normalize } from 'utils/normalize'

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case "GET_COUNTIES_SUCCESS":
        return { ...state, ...normalize(action.counties) }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/data/counties/reducer.js